import React, { useState } from 'react';
import { Plus } from "lucide-react";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { useSelector } from "react-redux";
import Loading from "../../component/Loading/Loading";
import useAxiosInstance from '../../services/useAxiosInstance';

const MonthlyFees = () => {
  const axiosInstance = useAxiosInstance();
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
  const communityId = useSelector((state) => state.auth.communityId);
  const userId = useSelector((state) => state.auth.userId);
  const clientId = useSelector((state) => state.auth.clientId);
  const [loading, setLoading] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [amount, setAmount] = useState('');
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setAmount(e.target.value);
  };

  const validateForm = () => {
    let formErrors = {};
    if (!amount) formErrors.amount = "Amount is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    console.log("communityId:", communityId);
    console.log("userId:", userId);
    console.log("clientId:", clientId);
    console.log("amount:", amount);

    try {
      const response = await axiosInstance.post(`/api/public/monthlyFees/request?amount=${amount}&communityId=${communityId}&createdById=${userId}`);
      console.log("response-> ",response)
      if (response.status === 200) {
        setAlert({ visible: true, message: 'Monthly fee request submitted successfully!', type: 'success' });
        setAmount('');
        setShowAddForm(false);
      } else {
        console.error('Unexpected response status:', response.status);
        setAlert({ visible: true, message: 'Failed to submit monthly fee request', type: 'error' });
      }
    } catch (error) {
      console.error('Error response:', error.response?.data || error.message);
      setAlert({ visible: true, message: 'Error submitting monthly fee request. Please try again later.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setAmount("");
    setErrors({});
    setShowAddForm(false);
  };

  return (
    <div className="bg-gray-50 h-fit">
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Monthly Fees</h1>
            <div className="flex items-center">
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                onClick={() => setShowAddForm(true)}
              >
                <Plus size={18} />
                <span>Add</span>
              </button>
            </div>
          </div>

          {showAddForm ? (
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <form className="p-4" onSubmit={handleSubmit}>
                <div className="flex flex-wrap gap-6 mb-6">
                  <div className="w-full md:w-[calc(50%-1.5rem)]">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Monthly Revenue Fee <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      id="amount"
                      name="amount"
                      value={amount}
                      onChange={handleChange}
                      required
                      className={`w-full rounded-md border ${errors.amount ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {errors.amount && <p className="text-red-500 text-xs mt-1">{errors.amount}</p>}
                  </div>
                </div>

                <div className="flex justify-between items-center">
                  <div className="text-sm text-red-500">* indicates required field</div>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6 p-8">
              <div className="text-center">
                <h2 className="text-lg font-medium text-gray-700 mb-2">Monthly Fee Management</h2>
                <p className="text-gray-500 mb-4">
                  Click the "Add" button to create a new monthly revenue fee request.
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MonthlyFees;